import { render, staticRenderFns } from "./redirect-banks-card.vue?vue&type=template&id=2d42a580&scoped=true"
import script from "./redirect-banks-card.vue?vue&type=script&lang=js"
export * from "./redirect-banks-card.vue?vue&type=script&lang=js"
import style0 from "./redirect-banks-card.vue?vue&type=style&index=0&id=2d42a580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d42a580",
  null
  
)

export default component.exports